export default {
    'replenish.spmc': '商品名称',
    'replenish.lx': '类型',
    'replenish.sl': '数量',
    'replenish.bh': '补货'
}